import { statusDashboardRoute, forgotPasswordRoute } from './../../core/routing/route-names';
import { AuthService } from '../services/auth.service';
import { OnInit, Component, OnDestroy, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { ToastService } from '../services/toast.service';
import { LoginModel } from '../shared/login.model';
import { SpinnerService } from '../spinner/spinner.service';
import { TranslateModule } from '@ngx-translate/core';

import { PasswordVisibilityDirective } from '../directives/password-visibility.directive';
import { AppErrorMessagesComponent } from '../error-messages/app-error-messages.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, PasswordVisibilityDirective, RouterLink, TranslateModule]
})
export class LoginComponent implements OnInit, OnDestroy {
  public loading = false;
  public loginModel: LoginModel = {} as LoginModel;

  public loginForm: UntypedFormGroup;
  public loginUserNameControl: UntypedFormControl;
  public loginPasswordControl: UntypedFormControl;
  public forgotPasswordRoute = forgotPasswordRoute;

  private initFlag;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
    private renderer: Renderer2) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'body-login');
    this.spinnerService.reset();
    this.initFlag = this.route.snapshot.queryParams.init;
    this.initializeForm();
    if (this.authService.isUserLoggedIn() && !this.initFlag) {
      this.router.navigate([statusDashboardRoute]);
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'body-login');
  }

  public login(): void {
    this.loading = true;

    this.loginModel.username = this.loginForm.value.userName;
    this.loginModel.password = this.loginForm.value.password;
    this.authService.login(this.loginModel).subscribe({
      next: (result) => {
        this.loading = false;

        if (result) {
          if (this.authService.redirectUrl) {
            this.router.navigateByUrl(this.authService.redirectUrl);
          } else {
            this.router.navigate([statusDashboardRoute]);
          }
        }
      },
      error: error => {
        this.loading = false;
        this.toastService.showApiException(error, 'i18n.core.messages.login.title', 'i18n.core.messages.login.message');
      }}
    );
  }

  private initializeForm(): void {
    this.loginUserNameControl = new FormControl(null, [Validators.required]);
    this.loginPasswordControl = new FormControl(null, [Validators.required]);
    this.loginForm = new UntypedFormGroup({
      userName: this.loginUserNameControl,
      password: this.loginPasswordControl
    });
  }
}
